import React, { useEffect, useState } from "react";
import "./style.css";
import { userPublications } from "../user.api";
import Loader from "../../../components/loader/loader";
import BreadCrumpBack from "../../../components/navigator/back";
import CustomIcons from "../../../components/icons/kIcons.component";
import moment from "moment";
import ReactHtmlParser from "react-html-parser";

export default function Publication(props) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const isMalayalam = props.state?.language === "ma";

  // Base URL calculation to remove 'api/' or similar suffix if needed, matching tenders.js logic
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance ? servInstance.substring(0, servInstance?.length - 4) : "";

  const getData = () => {
    setLoading(true);
    userPublications().then((res) => {
      let tdata = res.data || [];
      setData(tdata);
      setLoading(false);
    }).catch(err => {
      console.error(err);
      setLoading(false);
    });
  };

  useEffect(() => {
    getData();
  }, []);

  const handleLink = (linkurl) => {
    if (!linkurl) return;
    let urlLower = linkurl.toLowerCase();
    let urlStart = urlLower.substring(0, 4);
    if (urlStart === "http") {
      window.open(`${urlLower}`, "_blank");
    } else {
      window.open(`//${urlLower}`, "_blank");
    }
  };

  const handleDownloadProof = (file) => {
    if (!file) return;
    const path = file.startsWith("http") ? file : `${result}${file}`;
    window.open(path, "_blank");
  };

  return (
    <div className="tender bg-tender">
      <div>
        <div className="dash-banner ">
          <div className="tix">
            {isMalayalam ? "സ്പേസ്‌പാർക്ക് പ്രസിദ്ധീകരണങ്ങൾ" : "Spacepark Publications"}
          </div>
        </div>
      </div>
      <BreadCrumpBack />
      <Loader open={loading} />

      <div className="container p-50">
        <div className="bg-white">
          <div className="row tender-box">
            {data.length !== 0 ? (
              <>
                {data.map((item) => (
                  <div className="bg-tender p-30" key={item.id}>
                    <div className="tender-title mb-2">
                      <p
                        className="head "
                        style={{ overflowWrap: "break-word" }}
                      >
                        <u>
                          {isMalayalam
                            ? item?.title_ma
                            : item?.publication_title}
                        </u>
                      </p>
                    </div>

                    {/* Description */}
                    {(item?.description || item?.description_ma) && (
                      <div className="tender-datas">
                        <div className="col-lg-2 col-md-12 col-sm-12 label">
                          <p>{isMalayalam ? "വിവരണം" : "Description"}</p>
                        </div>
                        <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                          <div>
                            {ReactHtmlParser(
                              isMalayalam
                                ? item?.description_ma
                                : item?.description
                            )}
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Publisher */}
                    {(item?.publisher || item?.publisher_ma) && (
                      <div className="tender-datas">
                        <div className="col-lg-2 col-md-12 col-sm-12 label">
                          <p>{isMalayalam ? "പ്രസാധകൻ" : "Publisher"}</p>
                        </div>
                        <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                          <p>
                            {isMalayalam
                              ? item?.publisher_ma
                              : item?.publisher}
                          </p>
                        </div>
                      </div>
                    )}

                    {/* Posted Date */}
                    {item?.created_at && (
                      <div className="tender-datas">
                        <div className="col-lg-2 col-md-12 col-sm-12 label">
                          <p>{isMalayalam ? "പ്രസിദ്ധീകരിച്ച തീയതി" : "Publication Date"}</p>
                        </div>
                        <div className="col-lg-10 col-md-12 col-sm-12 contentx note">
                          <p>
                            {moment(item.created_at).format("DD-MM-YYYY")}
                          </p>
                        </div>
                      </div>
                    )}

                    {/* Link */}
                    {item?.link && (
                      <div className="tender-datas">
                        <div className="col-lg-2 col-md-12 col-sm-12 label">
                          <p>{isMalayalam ? "ലിങ്ക്" : "Link"}</p>
                        </div>
                        <div className="d-flex col-lg-10 col-md-12 col-sm-12 contentx overf">
                          <p className="blink_me">
                            <CustomIcons iconName={"hand"} />
                          </p>
                          <span>
                            &nbsp;
                            <a
                              onClick={() => handleLink(item.link)}
                              className="break_link"
                            >
                              {" "}
                              {item?.link}
                            </a>
                          </span>
                        </div>
                      </div>
                    )}

                    {/* Document */}
                    {item?.upload_image && (
                      <div className="tender-datas">

                        <div className="d-flex col-lg-12 col-md-12 col-sm-12 contentx overf justify-content-center">
                          {/* <p className="blink_me">
                          </p> */}
                          <span className="mt-2">
                            <button
                              type="button"
                              className="btn btn-adaptable-green"
                              onClick={() => handleDownloadProof(item.upload_image)}
                            >
                              {isMalayalam ? "അറ്റാച്ച്മെന്റ് ഡൗൺലോഡ്" : "Download Document"}
                            </button>
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </>
            ) : (
              <>
                <div className="no-data">
                  <img src="resources/img/no1.png" alt="" />
                  <h4>{isMalayalam ? "രേഖകളൊന്നും കണ്ടെത്തിയില്ല..!!" : "No Records Found..!!"}</h4>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
